<template>
  <div id="app">
    <Nav></Nav>
    <div class="toptit"></div>
    <div class="block">
      <h1>
        <span>公司</span>荣誉
      </h1>
    </div>
    <div class="honor">
      <div>
        <div class="titNum" :style="xianshi0" @click="qiehuan0">
          <div class="littleBlock" :style="block0"></div>
          <p class="honorTit" :style="titblock0">上海市文化创意产业促进会副会长单位</p>
        </div>
        <div class="titNum" :style="xianshi1" @click="qiehuan1">
          <div class="littleBlock" :style="block1"></div>
          <div>
            <p class="honorTit" :style="titblock1">团队奖</p>
          </div>
          <div class="honorContent" :style="titblock1">
            <p style="text-indent:23px">2017年度青浦区创新创业优秀人才团队奖</p>
            <p style="text-indent:23px">2018年度青浦区创新创业优秀人才团队奖</p>
          </div>
        </div>
        <div class="titNum" :style="xianshi2" @click="qiehuan2">
          <div class="littleBlock" :style="block2"></div>
          <div>
            <p class="honorTit" :style="titblock2">先进企业</p>
          </div>
          <div class="honorContent" :style="titblock2">
            <p>2018-2019年度 上海市先进民营企业</p>
          </div>
        </div>
        <div class="titNum" :style="xianshi3" @click="qiehuan3">
          <div class="littleBlock" :style="block3"></div>
          <p class="honorTit" :style="titblock3">上海市创意产业协会理事单位</p>
        </div>
        <div class="titNum" :style="xianshi4" @click="qiehuan4">
          <div class="littleBlock" :style="block4"></div>
          <p class="honorTit" :style="titblock4">高新技术企业</p>
        </div>
      </div>
      <div class="imgBlock">
        <div>
          <img src="../assets/rongyu/a.gif" :style="qiehuanImg0" alt />
          <img src="../assets/ry1.png" :style="qiehuanImg1" alt />
          <img src="../assets/rongyu/c.gif" :style="qiehuanImg2" alt />
          <img src="../assets/ry3.png" :style="qiehuanImg3" alt />
          <img src="../assets/ry4.png" :style="qiehuanImg4" alt />
        </div>
      </div>
    </div>
    <BottomNav></BottomNav>
    <div class="gongsirongyu-bg">
      <img src="../assets/gongsirongyu-bg.png" alt="">
    </div>
  </div>
</template>

<script>
import Nav from "../components/Nav";
import BottomNav from "../components/BottomNav";
import Vue from "vue";
export default {
  name: "Honor",
  data() {
    return {
      tabPosition: "left",
      xianshi0: [{ backgroundColor: "#333" }],
      xianshi1: [{ backgroundColor: "#fff" }],
      xianshi2: [{ backgroundColor: "#fff" }],
      xianshi3: [{ backgroundColor: "#fff" }],
      xianshi4: [{ backgroundColor: "#fff" }],
      block0: [{ backgroundColor: "#FCE04F" }],
      block1: [{ backgroundColor: "#fff" }],
      block2: [{ backgroundColor: "#fff" }],
      block3: [{ backgroundColor: "#fff" }],
      block4: [{ backgroundColor: "#fff" }],
      titblock0: [{ color: "#fff" }],
      titblock1: [{ color: "#666" }],
      titblock2: [{ color: "#666" }],
      titblock3: [{ color: "#666" }],
      titblock4: [{ color: "#666" }],
      qiehuanImg0: [{ display: "block" }],
      qiehuanImg1: [{ display: "none" }],
      qiehuanImg2: [{ display: "none" }],
      qiehuanImg3: [{ display: "none" }],
      qiehuanImg4: [{ display: "none" }]
    };
  },
  methods: {
    qiehuan0() {
        (this.xianshi1 = [{ backgroundColor: "#fff" }]),
        (this.xianshi2 = [{ backgroundColor: "#fff" }]),
        (this.xianshi0 = [{ backgroundColor: "#333" }]),
        (this.xianshi3 = [{ backgroundColor: "#fff" }]),
        (this.xianshi4 = [{ backgroundColor: "#fff" }]),
        (this.block0 = [{ backgroundColor: "#FCE04F" }]),
        (this.block1 = [{ backgroundColor: "#fff" }]),
        (this.block2 = [{ backgroundColor: "#fff" }]),
        (this.block3 = [{ backgroundColor: "#fff" }]),
        (this.block4 = [{ backgroundColor: "#fff" }]),
        (this.titblock0 = [{ color: "#fff" }]),
        (this.titblock2 = [{ color: "#666" }]),
        (this.titblock3 = [{ color: "#666" }]),
        (this.titblock1 = [{ color: "#666" }]),
        (this.titblock4 = [{ color: "#666" }]);
        (this.qiehuanImg0 = [{ display: "block" }]),
        (this.qiehuanImg1 = [{ display: "none" }]),
        (this.qiehuanImg2 = [{ display: "none" }]),
        (this.qiehuanImg3 = [{ display: "none" }]),
        (this.qiehuanImg4 = [{ display: "none" }]);
    },
    qiehuan1() {
      (this.xianshi1 = [{ backgroundColor: "#333" }]),
        (this.xianshi2 = [{ backgroundColor: "#fff" }]),
        (this.xianshi0 = [{ backgroundColor: "#fff" }]),
        (this.xianshi3 = [{ backgroundColor: "#fff" }]),
        (this.xianshi4 = [{ backgroundColor: "#fff" }]),
        (this.block1 = [{ backgroundColor: "#FCE04F" }]),
        (this.block0 = [{ backgroundColor: "#fff" }]),
        (this.block2 = [{ backgroundColor: "#fff" }]),
        (this.block3 = [{ backgroundColor: "#fff" }]),
        (this.block4 = [{ backgroundColor: "#fff" }]),
        (this.titblock1 = [{ color: "#fff" }]),
        (this.titblock2 = [{ color: "#666" }]),
        (this.titblock3 = [{ color: "#666" }]),
        (this.titblock0 = [{ color: "#666" }]),
        (this.titblock4 = [{ color: "#666" }]);
        (this.qiehuanImg1 = [{ display: "block" }]),
        (this.qiehuanImg0 = [{ display: "none" }]),
        (this.qiehuanImg2 = [{ display: "none" }]),
        (this.qiehuanImg3 = [{ display: "none" }]),
        (this.qiehuanImg4 = [{ display: "none" }]);
    },
    qiehuan2() {
      (this.xianshi1 = [{ backgroundColor: "#fff" }]),
        (this.xianshi2 = [{ backgroundColor: "#333" }]),
        (this.xianshi3 = [{ backgroundColor: "#fff" }]),
        (this.xianshi4 = [{ backgroundColor: "#fff" }]),
        (this.xianshi0 = [{ backgroundColor: "#fff" }]),
        (this.block1 = [{ backgroundColor: "#fff" }]),
        (this.block2 = [{ backgroundColor: "#FCE04F" }]),
        (this.block0 = [{ backgroundColor: "#fff" }]),
        (this.block3 = [{ backgroundColor: "#fff" }]),
        (this.block4 = [{ backgroundColor: "#fff" }]),
        (this.titblock1 = [{ color: "#666" }]),
        (this.titblock2 = [{ color: "#fff" }]),
        (this.titblock0 = [{ color: "#666" }]),
        (this.titblock3 = [{ color: "#666" }]),
        (this.titblock4 = [{ color: "#666" }]);
        (this.qiehuanImg1 = [{ display: "none" }]),
        (this.qiehuanImg2 = [{ display: "block" }]),
        (this.qiehuanImg3 = [{ display: "none" }]),
        (this.qiehuanImg0 = [{ display: "none" }]),
        (this.qiehuanImg4 = [{ display: "none" }]);
    },
    qiehuan3() {
      (this.xianshi1 = [{ backgroundColor: "#fff" }]),
        (this.xianshi2 = [{ backgroundColor: "#fff" }]),
        (this.xianshi3 = [{ backgroundColor: "#333" }]),
        (this.xianshi4 = [{ backgroundColor: "#fff" }]),
        (this.xianshi0 = [{ backgroundColor: "#fff" }]),
        (this.block1 = [{ backgroundColor: "#fff" }]),
        (this.block2 = [{ backgroundColor: "#fff" }]),
        (this.block3 = [{ backgroundColor: "#FCE04F" }]),
        (this.block4 = [{ backgroundColor: "#fff" }]),
        (this.block0 = [{ backgroundColor: "#fff" }]),
        (this.titblock1 = [{ color: "#666" }]),
        (this.titblock2 = [{ color: "#666" }]),
        (this.titblock3 = [{ color: "#fff" }]),
        (this.titblock4 = [{ color: "#666" }]);
        (this.titblock0 = [{ color: "#666" }]);
        (this.qiehuanImg1 = [{ display: "none" }]),
        (this.qiehuanImg2 = [{ display: "none" }]),
        (this.qiehuanImg0 = [{ display: "none" }]),
        (this.qiehuanImg3 = [{ display: "block" }]),
        (this.qiehuanImg4 = [{ display: "none" }]);
    },
    qiehuan4() {
      (this.xianshi1 = [{ backgroundColor: "#fff" }]),
        (this.xianshi2 = [{ backgroundColor: "#fff" }]),
        (this.xianshi0 = [{ backgroundColor: "#fff" }]),
        (this.xianshi3 = [{ backgroundColor: "#fff" }]),
        (this.xianshi4 = [{ backgroundColor: "#333" }]),
        (this.block1 = [{ backgroundColor: "#fff" }]),
        (this.block2 = [{ backgroundColor: "#fff" }]),
        (this.block0 = [{ backgroundColor: "#fff" }]),
        (this.block3 = [{ backgroundColor: "#fff" }]),
        (this.block4 = [{ backgroundColor: "#FCE04F" }]),
        (this.titblock1 = [{ color: "#666" }]),
        (this.titblock2 = [{ color: "#666" }]),
        (this.titblock0 = [{ color: "#666" }]),
        (this.titblock3 = [{ color: "#666" }]),
        (this.titblock4 = [{ color: "#fff" }]);
        (this.qiehuanImg1 = [{ display: "none" }]),
        (this.qiehuanImg2 = [{ display: "none" }]),
        (this.qiehuanImg0 = [{ display: "none" }]),
        (this.qiehuanImg3 = [{ display: "none" }]),
        (this.qiehuanImg4 = [{ display: "block" }]);
    }
  },
  mounted() {
    window.onscroll = function() {
      var scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;
      var topNav = document.getElementById("topNav");
      if (scrollTop > 0) {
        topNav.style.width = "100%";
        topNav.style.position = "fixed";
        topNav.style.top = "0";
        topNav.style.left = "0";
        topNav.style.paddingLeft = "33.5%";
        // topNav.style.zIndex = 11;

      } else{
        // topNav.style.paddingLeft = "0%";
        // topNav.style.width = "32.42%";
        // topNav.style.left = "33.5%";
        // topNav.style.zIndex = 9;

      }
      // if (scrollTop = 0) {
      //   topNav.style.width = "29.42%";
      // }
    };
  },
  components: { Nav, BottomNav }
};
</script>

<style lang="less" scoped>
#app {
  font-family: "微软雅黑";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  position: relative;
  @media screen and (min-width: 140px) {
    min-width: 1050px;
    margin: 0 auto;
  }
  @media screen and (min-width: 1920px) {
    min-width: 1240px;
    margin: 0 auto;
  }
}
.image {
  width: 100%;
}
.logoImg {
  width: 141px;
  height: 86px;
}
.gongsirongyu-bg{
  position: absolute;
  top: 0%;
  z-index: -10;
  img{
    width: 100%;
  }
}
.tit {
  text-align: left;
  h1 {
    color: #fce04f;
    font-size: 61px;
    font-family: Impact;
    font-weight: 400;
    border-bottom: 4px solid #fce04f;
    width: 67px;
  }
  p {
    font-size: 20px;
    padding-bottom: 15px;
  }
}
.block {
  background-color: #333333;
  height: 100px;
  display: flex;
  align-items: center;
  h1 {
    color: #ffffff;
    line-height: 100px;
    width: fit-content;
    width: -webkit-fit-content;
    width: -moz-fit-content;
    margin: 0 0 0 35%;
    @media screen and (min-width: 140px) {
        font-size: 24px;
      }
    @media screen and (min-width: 1920px) {
      font-size: 26px;
    }
    span {
      border-bottom: 4px solid #fce04f;
      padding-bottom: 5px;
    }
  }
}
.toptit {
  width: 100%;
  height: 56px;
}
.honor {
  padding: 50px 0;
  margin: 0 auto;
  display: flex;
  width: 65%;
  justify-content: space-between;
  @media screen and (min-width: 140px) {
    width: 85%;
  }
  @media screen and (min-width: 1380px) {
    width: 65%;
  }
  & > div {
    width: 50%;
    // min-width: 607px;
    .titNum {
      display: flex;
      align-items: center;
      width: 100%;
      height: 20%;
      position: relative;
      background-color: #333;
      padding-left: 1px;
      .littleBlock {
        height: 50px;
        width: 50px;
        position: absolute;
        background-color: #fce04f;
        top: 50%;
        margin-top: -25px;
        margin-left: -20px;
        z-index: 100;
      }
      p {
        margin: 0;
      }
      .honorTit {
        color: #ffffff;
        font-weight: bold;
        font-size: 24px;
        padding-left: 50px;
        @media screen and (min-width: 140px) {
          font-size: 18px;
        }
        @media screen and (min-width: 1920px) {
          font-size: 24px;
        }
      }
      .honorContent {
        color: #ffffff;
        font-size: 16px;
        p {
          text-align: left;
          padding-left: 20px;
          @media screen and (min-width: 140px) {
            font-size: 14px;
          }
          @media screen and (min-width: 1920px) {
            font-size: 16px;
          }
        }
      }
    }
    .titNum:hover {
      cursor: pointer;
    }
  }
  .imgBlock {
    width: 50%;
    background-color: #333333;
    padding: 28px 30px 29px 39px;
    div {
      background-color: #fce04f;
      padding: 37px 42px;
      width: 82%;
      position: relative;
      img {
        width: 100%;
        // position: absolute;
        // left: 42px;
      }
    }
  }
}
</style>
<style lang="less">
// .el-submenu__title:hover{
//   background-color: #fff !important;
// }
.el-submenu__title{
  color: #333 !important;
}
.el-submenu__title a{
  color: #333 !important;
}
// .el-carousel__container {
//   height: 500px;
// }
</style>
